<ds-card class="card-content" shadow="l2" gap="var(--ds-foundation-spacing-ms)">
  <header class="card-header">
    <h3 class="ds-text-h3-s-bold">Carga tu documentación</h3>
    <p class="ds-text-body-s-regular">Adjunta los documentos que son necesarios para la solicitud.
    </p>
  </header>

  <ds-card background="var(--ds-foundation-colors-neutral-100)" shadow="none" gap="var(--ds-foundation-spacing-ms)">

    <header class="card-header">
      <h4 class="ds-text-h4-s-bold">Documentos personales</h4>
      <p class="ds-text-body-s-regular">Carga tu cédula de identidad y certificado de nacimiento.</p>
    </header>

    <!-- cedula de identidad -->
    <app-pi-document-status [type]="'cedula-de-identidad'" [title]="'Cédula de Identidad'"
      [status]="status['cedula-de-identidad']" [errorMessage]="errorMessages['cedula-de-identidad']"
      [cachedDocument]="documentosCache['cedula-de-identidad']"
      (documentType)="setDocumentType($event)" (fileSelected)="onFileSelected($event)"
      (cancelQuery)="cancelQuery($event, 'cedula-de-identidad')"
      (deleteDoc)="delDocument($event)"></app-pi-document-status>

    <!-- certificado de nacimiento -->
    <app-pi-document-status [type]="'nacimiento'" [title]="'Certificado de Nacimiento (*)'" [status]="status.nacimiento"
      [errorMessage]="errorMessages['nacimiento']" [cachedDocument]="documentosCache['nacimiento']"
      (documentType)="setDocumentType($event)"
      (fileSelected)="onFileSelected($event)" (cancelQuery)="cancelQuery($event, 'nacimiento')"
      (deleteDoc)="delDocument($event)"></app-pi-document-status>

  </ds-card>

  <ng-container *ngIf="conyuge || convivienteCivil">

    <ds-card background="var(--ds-foundation-colors-neutral-100)" shadow="none">

      <header class="card-header">
        <h4 class="ds-text-h4-s-bold">Documentos cónyuge</h4>
        <p class="ds-text-body-s-regular">Carga el certificado de nacimiento del cónyuge, certificado de matrimonio o
          unión civil, según corresponda.
        </p>
      </header>

      <!-- certificado de nacimiento conyuge -->
      <app-pi-document-status [type]="'nacimiento-conyuge'" [title]="'Certificado de Nacimiento Cónyuge (*)'"
        [status]="status['nacimiento-conyuge']" [errorMessage]="errorMessages['nacimiento-conyuge']"
        [cachedDocument]="documentosCache['nacimiento-conyuge']"
        (documentType)="setDocumentType($event)" (fileSelected)="onFileSelected($event)"
        (cancelQuery)="cancelQuery($event, 'nacimiento-conyuge')" (deleteDoc)="delDocument($event)"
        *ngIf="conyuge"></app-pi-document-status>

      <!-- certificado de nacimiento conviviente civil -->
      <app-pi-document-status [type]="'nacimiento-conyuge'" [title]="'Certificado de Nacimiento Conviviente Civil (*)'"
        [status]="status['nacimiento-conyuge']" [errorMessage]="errorMessages['nacimiento-conyuge']"
        [cachedDocument]="documentosCache['nacimiento-conyuge']"
        (documentType)="setDocumentType($event)" (fileSelected)="onFileSelected($event)"
        (cancelQuery)="cancelQuery($event, 'nacimiento-conyuge')" (deleteDoc)="delDocument($event)"
        *ngIf="convivienteCivil"></app-pi-document-status>

      <!-- certificado de matrimonio -->
      <app-pi-document-status [type]="'matrimonio'" [title]="'Certificado de Matrimonio (*)'"
        [status]="status.matrimonio" [errorMessage]="errorMessages['matrimonio']"
        [cachedDocument]="documentosCache['matrimonio']"
        (documentType)="setDocumentType($event)" (fileSelected)="onFileSelected($event)"
        (cancelQuery)="cancelQuery($event, 'matrimonio')" (deleteDoc)="delDocument($event)"
        *ngIf="conyuge"></app-pi-document-status>

      <!-- certificado de unión civil -->
      <app-pi-document-status [type]="'union-civil'" [title]="'Certificado de Unión Civil (*)'"
        [status]="status['union-civil']" [errorMessage]="errorMessages['union-civil']"
        [cachedDocument]="documentosCache['union-civil']"
        (documentType)="setDocumentType($event)" (fileSelected)="onFileSelected($event)"
        (cancelQuery)="cancelQuery($event, 'union-civil')" (deleteDoc)="delDocument($event)"
        *ngIf="convivienteCivil"></app-pi-document-status>
    </ds-card>
  </ng-container>

  <ng-container *ngIf="beneficiarios.length > 0;">

    <ds-card background="var(--ds-foundation-colors-neutral-100)" shadow="none">

      <header class="card-header">
        <h4 class="ds-text-h4-s-bold">Documentos beneficiarios</h4>
        <p class="ds-text-body-s-regular">Carga los certificados de nacimiento de tus beneficiarios, según corresponda.
        </p>
      </header>

      <!-- certificado de nacimiento conyuge -->
      <ng-container *ngFor="let beneficiario of beneficiarios; let i = index">
        <p class="documents-beneficiary-description">
          Beneficiario {{ i + 1 }}: {{ getNombreCompletoBeneficiario(beneficiario) }}
        </p>
        <app-pi-document-status [type]="beneficiaryDocumentKeys[i]"
          [title]="'Certificado de Nacimiento Beneficiario ' + (i + 1) + ' (*)'"
          [status]="status[beneficiaryDocumentKeys[i]]" [errorMessage]="errorMessages[beneficiaryDocumentKeys[i]]"
          [cachedDocument]="documentosCache[beneficiaryDocumentKeys[i]]"
          (documentType)="setDocumentType($event)" (fileSelected)="onFileSelected($event)"
          (cancelQuery)="cancelQuery($event, beneficiaryDocumentKeys[i])"
          (deleteDoc)="delDocument($event)"></app-pi-document-status>
      </ng-container>
    </ds-card>
  </ng-container>
  <div *ngIf="loadingBeneficiarios">
    <ds-skeleton></ds-skeleton>
  </div>


  <ds-inline-alert type="info" emphasis="outline" title="¿Te faltan documentos?" icon="Info">
    <span class="pi-requisitos__alert-text">Puedes descargarlos en
      <a href="https://www.registrocivil.cl/" target="_blank"
        rel="noopener noreferrer" aria-label="Ir a www.registrocivil.cl, se abre en una nueva pestaña"
        (click)="abrirRegistroCivil($event)">www.registrocivil.cl</a>.</span>
  </ds-inline-alert>

</ds-card>